const phoneEncrypt = {
  mounted(el, binding) {
    const value = String(binding.value);
    const mask = binding.arg || 4; // 默认掩盖 4 位数字
    
    // 正则验证手机号格式
    const phoneRegex = /^(\d{3})\d{4}(\d{4})$/;

    // 判断传入的值是否符合手机号格式
    if (phoneRegex.test(value)) {      
      const encryptedPhone = value.replace(
        phoneRegex,
        `$1${"*".repeat(mask)}$2`
      );      
      
      el.textContent = encryptedPhone; // 修改 DOM 内容
    } else {
      console.warn("Invalid phone number format!");
      el.textContent = value; // 如果手机号格式不正确，直接显示原值
    }
  },
};

export default phoneEncrypt;